module.exports = __webpack_public_path__ + "img/bd87502.jpg";